// PGCET MCA Mock 9 — General English (questions 91–100)
const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Arrange the sentences to form a coherent paragraph: P: Within a few years, the practice had spread to almost every village in the district. Q: In 2005, a small group of farmers in Mandya began collecting rainwater in farm ponds. R: Encouraged by the results, their neighbours soon dug ponds of their own. S: The stored water helped them save their crops during a long dry spell.",
    options: ["A. QRSP", "B. QSRP", "C. SQRP", "D. QSPR"],
    answer: "B"
  },
  {
    id: 92,
    question: "Find the part of the sentence that contains an error: The police has arrested (A) / the thief who stole (B) / the jewellery from the shop (C) / No error (D)",
    options: ["A. The police has arrested", "B. the thief who stole", "C. the jewellery from the shop", "D. No error"],
    answer: "A"
  },
  {
    id: 93,
    question: "Find the part of the sentence that contains an error: Neither of the two candidates (A) / who appeared for the interview (B) / were selected for the post (C) / No error (D)",
    options: ["A. Neither of the two candidates", "B. who appeared for the interview", "C. were selected for the post", "D. No error"],
    answer: "C"
  },
  {
    id: 94,
    question: "Choose the correct preposition: She was so absorbed ______ reading the novel that she did not hear the doorbell.",
    options: ["A. at", "B. with", "C. in", "D. on"],
    answer: "C"
  },
  {
    id: 95,
    question: "Choose the correct preposition: My grandfather has been suffering ______ a high fever since Monday.",
    options: ["A. with", "B. by", "C. of", "D. from"],
    answer: "D"
  },
  {
    id: 96,
    question: "Choose the pair of words that shows the same relationship as AUTHOR : NOVEL",
    options: ["A. Sculptor : Statue", "B. Teacher : School", "C. Doctor : Hospital", "D. Singer : Microphone"],
    answer: "A"
  },
  {
    id: 97,
    question: "Complete the analogy: PEN : WRITE :: KNIFE : ?",
    options: ["A. Sharp", "B. Cut", "C. Steel", "D. Kitchen"],
    answer: "B"
  },
  {
    id: 98,
    question: "Read the passage and answer the question: \"Millets such as ragi, jowar and bajra were once the staple grains of large parts of India, including Karnataka, where ragi mudde remains a popular meal. During the Green Revolution, however, government support shifted heavily towards rice and wheat, and millet cultivation steadily declined. Nutritionists now point out that millets are rich in fibre, iron and calcium and have a low glycaemic index, making them valuable in the fight against diabetes. They also need far less water than paddy and can grow on poor soils, which makes them attractive to farmers facing erratic rainfall. Reviving millets, experts argue, will require not only better prices for farmers but also a change in the eating habits of urban consumers.\" According to the passage, why did millet cultivation decline?",
    options: [
      "A. Millets could not be grown on poor soils",
      "B. Government support shifted heavily towards rice and wheat",
      "C. Urban consumers found millets too expensive",
      "D. Millets required too much irrigation water"
    ],
    answer: "B"
  },
  {
    id: 99,
    question: "Read the passage and answer the question: \"Millets such as ragi, jowar and bajra were once the staple grains of large parts of India, including Karnataka, where ragi mudde remains a popular meal. During the Green Revolution, however, government support shifted heavily towards rice and wheat, and millet cultivation steadily declined. Nutritionists now point out that millets are rich in fibre, iron and calcium and have a low glycaemic index, making them valuable in the fight against diabetes. They also need far less water than paddy and can grow on poor soils, which makes them attractive to farmers facing erratic rainfall. Reviving millets, experts argue, will require not only better prices for farmers but also a change in the eating habits of urban consumers.\" Which feature of millets makes them attractive to farmers facing erratic rainfall?",
    options: [
      "A. Their high glycaemic index",
      "B. Their rich calcium content",
      "C. They need far less water than paddy",
      "D. They always fetch high market prices"
    ],
    answer: "C"
  },
  {
    id: 100,
    question: "Read the passage and answer the question: \"Millets such as ragi, jowar and bajra were once the staple grains of large parts of India, including Karnataka, where ragi mudde remains a popular meal. During the Green Revolution, however, government support shifted heavily towards rice and wheat, and millet cultivation steadily declined. Nutritionists now point out that millets are rich in fibre, iron and calcium and have a low glycaemic index, making them valuable in the fight against diabetes. They also need far less water than paddy and can grow on poor soils, which makes them attractive to farmers facing erratic rainfall. Reviving millets, experts argue, will require not only better prices for farmers but also a change in the eating habits of urban consumers.\" The word 'erratic' as used in the passage most nearly means",
    options: ["A. Abundant", "B. Seasonal", "C. Gentle", "D. Unpredictable"],
    answer: "D"
  }
];

export default pgcetmcaGeneralEnglish;
